import { classNames } from "../../UI/Utils/classNames.ts";

export function OrderKindTabs<Kind extends string>({
  labels,
  value,
  onChange,
}: {
  labels: Record<Kind, string>;
  value: Kind;
  onChange: (kind: Kind) => void;
}) {
  return (
    <div
      role="tablist"
      className="inline-flex flex-wrap self-start rounded-lg border border-gray-200 bg-white p-1"
    >
      {(Object.keys(labels) as Kind[]).map((kind) => (
        <button
          key={kind}
          type="button"
          role="tab"
          aria-selected={value === kind}
          onClick={() => onChange(kind)}
          className={classNames(
            "px-4 py-1.5 rounded-md text-sm font-medium transition-colors",
            value === kind
              ? "bg-primary text-white"
              : "text-gray-600 hover:bg-gray-50",
          )}
        >
          {labels[kind]}
        </button>
      ))}
    </div>
  );
}
